import { Box, Flex, Heading, HStack, Stack, VStack } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import { localise, templateReplace } from '../../../services/lang/lang';
import NotesPanel from './NotesPanel';
import PhotoGrid from './PhotoGrid';
import HazardsPanel from './HazardsPanel';
import ElementsPanel from './ElementsPanel';
import ActionPanel from './ActionPanel';
import ResponsiveStack from './ResponsiveStack';
import { RenderIf } from '../RenderIf/RenderIf';
import LocationPanel from './LocationPanel';
import { FindingsActionMenu } from '../FindingsActionMenu/FindingsActionMenu';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import ResponsiveInnerPanel from './ResponsiveInnerPanel';
const FindingPanel = ({ finding, kind, loadedPhotos, hasStartedScrolling, }) => {
    const { isShare } = useInspectionDetailContext();
    const tokens = useTokens();
    const styles = {
        outerPanel: {
            bgColor: tokens.CanvasPrimary100,
            w: '100%',
            minH: '296px',
            padding: tokens.Spacing05,
            my: tokens.Spacing05,
            borderRadius: tokens.BorderRadius02,
            h3: {
                display: 'block',
                w: '100%',
            },
        },
        mainStack: {
            flexDirection: 'row',
            gap: 4,
            width: {
                base: '80%',
                sm: '100%',
                md: '100%',
                xl: '80%',
            },
        },
        subStack: {
            flexDirection: {
                base: 'column',
                sm: 'row',
                md: 'row',
                xl: 'column',
            },
            width: {
                base: '40%',
                sm: '100%',
                md: '100%',
                xl: '40%',
            },
        },
        innerPanel: {
            bgColor: tokens.CanvasPrimary200,
            py: tokens.Spacing03,
            px: tokens.Spacing04,
            borderRadius: tokens.BorderRadius02,
            panelText: {
                wordBreak: 'keep-all',
                whiteSpace: 'normal',
            },
        },
    };
    return (React.createElement(Box, { sx: styles.outerPanel, "data-testid": "finding-panel" },
        React.createElement(HStack, null,
            React.createElement(VStack, { w: "100%" },
                React.createElement(Flex, { w: "full", align: "center", justifyContent: "space-between", mt: `-${tokens.Spacing03}`, mb: `-${tokens.Spacing02}` },
                    React.createElement(Heading, { variant: "dk-800-md-6", as: "h3", "data-testid": "finding-panel__reference" }, templateReplace(localise('FINDING_REFERENCE'), {
                        reference: finding.reference,
                    })),
                    React.createElement(FindingsActionMenu, { hasStartedScrolling: hasStartedScrolling, finding: finding })),
                React.createElement(ResponsiveStack, { gap: tokens.Spacing05, w: "100%" },
                    React.createElement(Stack, { sx: styles.mainStack },
                        React.createElement(PhotoGrid, { finding: finding, loadedPhotos: loadedPhotos, shouldLoadPhotos: true, isShare: isShare }),
                        React.createElement(Flex, { sx: styles.innerPanel, padding: tokens.Spacing04, maxH: "228px", w: "100%" },
                            React.createElement(NotesPanel, { notes: finding.notes }))),
                    React.createElement(ResponsiveStack, { sx: styles.subStack },
                        React.createElement(Stack, { flexDirection: { md: 'row', xl: 'column' }, w: "100%", h: { md: '140px', xl: '228px' } },
                            React.createElement(RenderIf, { condition: kind === 'location' },
                                React.createElement(ResponsiveInnerPanel, { size: "small" },
                                    React.createElement(ResponsiveStack, null,
                                        React.createElement(ActionPanel, { action: finding.action_type })))),
                            React.createElement(RenderIf, { condition: kind === 'hazard' },
                                React.createElement(LocationPanel, { location: finding.location })),
                            React.createElement(ElementsPanel, { elements: finding.elements }),
                            React.createElement(ResponsiveInnerPanel, { size: "big" },
                                React.createElement(ResponsiveStack, { "data-testid": "finding-panel__hazards-box" },
                                    React.createElement(HazardsPanel, { hazards: finding.hazards }))))))))));
};
export default FindingPanel;
